import React from 'react';
import { useAtom } from '@gothub-team/got-atom';
import { LoggedIn, screenNav } from '../state/states';
import LandLordMain from '../landlord/LandLordMain';
import TenantMain from '../tenant/TenantMain';
import AdminMain from '../admin/AdminMain';
import LandLordMainMobile from '../Mobile/Landlord/LandLordMainMobile';
import TenantMainMobile from '../Mobile/Tenant/TenantMainMobile';
import { LandLordNoZev } from '../landlord/LandLordNoZev';
import { TenantNoMeter } from '../tenant/TenantNoMeter';
import Landing from './Landing';
import Imprint from './Imprint';
import Gdpr from './Gdpr';

export default function ScreenNav({ mobile }) {
    const nav = useAtom(screenNav);
    const loggedIn = useAtom(LoggedIn);

    if (loggedIn !== 'loggedIn') {
        if (nav === 'imprint') return <Imprint />;
        if (nav === 'gdpr') return <Gdpr />;
        return <Landing mobile={mobile} />;
    } else if (mobile) {
        if (nav === 'landlord-main') {
            return <LandLordMainMobile />;
        } else if (nav === 'landlord-no-zev') {
            return <LandLordNoZev />;
        } else if (nav === 'tenant-main') {
            return <TenantMainMobile />;
        } else if (nav === 'tenant-no-meter') {
            return <TenantNoMeter />;
        } else {
            return null;
        }
    } else {
        if (nav === 'landlord-main') {
            return <LandLordMain />;
        } else if (nav === 'landlord-no-zev') {
            return <LandLordNoZev />;
        } else if (nav === 'tenant-main') {
            return <TenantMain />;
        } else if (nav === 'tenant-no-meter') {
            return <TenantNoMeter />;
        } else if (nav === 'admin') {
            return <AdminMain />;
        } else {
            return null;
        }
    }
}
